import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Row, Col, Form, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import config from "../../config/config";
import axios from "axios";
import { toast } from 'react-toastify';
import Loader from "../loader/Loader";
import { getAuthToken } from "../../utils/token";
import { formatDate } from "../../utils/formatDate"
export default function ModificationProductionProduct({ show, handleClose, modificationId,refreshParent }) {
  const [loading, setLoading] = useState(false);
  const [modification, setModification] = useState([]);
  const [qtyPending, setQtyPending] = useState("");
  const [poplan, setPoplan] = useState([])
  const [selectedMonth, setSelectedMonth] = useState("");
  const [stockplan, setStockplan] = useState(null)
  // Fetch modification data
  const fetchModification = async () => {
    const token = getAuthToken();
    if (!token) return;

    setLoading(true);
    try {
      const response = await axios.get(
        `${config.API}/manager/modificationtoproductionplanproduct/${modificationId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const plans = response?.data?.plans || [];
      setModification(plans || []);
      setStockplan(response?.data?.stock || [])
      setPoplan(response?.data?.poplan || [])
    } catch (err) {
      console.error("Error fetching data:", err.message);
      setModification([]);
    } finally {
      setLoading(false);
    }
  };

  // Submit qty_pending
  const modificationSubmit = async () => {
    const token = getAuthToken();
    if (!token) return;

    const payload = Object.keys(qtyPending)
      .filter(month => qtyPending[month] !== "" && !isNaN(qtyPending[month]))
      .map(month => ({
        month,
        qty_pending: Number(qtyPending[month])
      }));

    if (payload.length === 0) {
      toast.warning("Please enter Qty Pending for at least one month");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${config.API}/manager/modificationtoproductionplanproduct/${modificationId}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(res?.data?.message || "Updated successfully");
      setQtyPending({});
      await refreshParent();
      handleClose();

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  if (show && modificationId) {
    fetchModification();
  }
}, [show, modificationId]);

  if (loading) return <Loader />;
  if (!modification || modification.length === 0) return null;

  const product = modification[0]?.product;

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered className="font_family">
      <Modal.Header closeButton>
        <h5 className="fw-bold mb-4">Modification to Production Plan (Product)</h5>
      </Modal.Header>
      {
        loading ? (
          <Loader />
        ) : (
          <Modal.Body className="">
            <Container fluid>
              {/* Product Details */}
              <div className="bg-light p-3 rounded mb-4 border">
                <h6 className="fw-bold mb-3">Product Details</h6>
                <Row>
                  <Col xs={12} md={4}><strong>Name:</strong> {product?.name}</Col>
                  <Col xs={12} md={4}><strong>ID:</strong> {product?.product_code}</Col>
                  <Col xs={12} md={4}><strong>Category:</strong> {product?.category || "Rubber"}</Col>
                </Row>
                <Row className="mt-2">
                  <Col xs={12} md={4}><strong>Stock:</strong> {stockplan}</Col>
                </Row>
              </div>

              {/* PO Table */}
              <h6 className="fw-bold mb-3">POs for Product</h6>
              <Table responsive hover bordered>
                <thead>
                  <tr>
                    <th>PO ID</th>
                    <th>QTY REQUIRED</th>
                    <th>QTY PRODUCED</th>
                    <th>QTY PENDING</th>
                    <th>INSPECTION DATE</th>
                  </tr>
                </thead>
                <tbody>
                  {poplan.map(item => {
                    const qty_pending =
                      Number(item?.order_quantity ?? 0) -
                      Number(item?.produced_quantity ?? 0)
                    return (
                      <tr key={item.id}>
                        <td>{item?.po_number}</td>
                        <td>{item?.order_quantity}</td>
                        <td>{item.produced_quantity}</td>
                        <td>{qty_pending}</td>
                        <td>{formatDate(item?.inspection_date)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>

              {/* Production Plan Table */}
              <h6 className="fw-bold mb-3">Production Plan</h6>
              <Table responsive bordered>
                <thead>
                  <tr>
                    <th>Month</th>
                    <th>Original Plan</th>
                    <th>Updated Plan (Qty Pending)</th>
                  </tr>
                </thead>
                <tbody>
                  {modification.map(plan => {
                    const qty_required =
                      Number(plan?.qty_produced ?? 0) +
                      Number(plan?.qty_pending ?? 0) +
                      Number(plan?.qty_delivered ?? 0);
                    return (
                      <tr key={plan.id}>
                        <td><Form.Control readOnly value={plan.month} /></td>
                        <td><Form.Control readOnly value={qty_required} /></td>
                        <td>
                          <Form.Control
                            type="number"
                            placeholder="Input Qty Pending"
                            value={qtyPending[plan.month] || ""}
                            onChange={(e) => {
                              setQtyPending(prev => ({
                                ...prev,
                                [plan.month]: e.target.value
                              }));
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>

              <div className="text-end mt-3">
                <Button variant="dark" onClick={modificationSubmit}>Save Production Plan</Button>
              </div>
            </Container>
          </Modal.Body>
        )
      }
    </Modal>
  );
}




